var _feGaussianBlur, _use, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 345 230",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5903438f-a8d5-4f7e-8512-d43fb7b2d043__cb-background",
    x1: "0%",
    y1: "32%",
    x2: "100%",
    y2: "68%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2b307a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    style: {
      stopColor: "#094c99",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    style: {
      stopColor: "#1972b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#c7b8c8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    style: {
      stopColor: "#d16761",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    style: {
      stopColor: "#d32724",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#cc191b",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "srgb"
    },
    id: "5903438f-a8d5-4f7e-8512-d43fb7b2d043__radg-filter01",
    x: -0.839,
    y: -0.855,
    width: 2.679,
    height: 2.709
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.195
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h345v230H0Z",
    style: {
      fill: "url('#5903438f-a8d5-4f7e-8512-d43fb7b2d043__cb-background')"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#fff",
      filter: "url('#5903438f-a8d5-4f7e-8512-d43fb7b2d043__radg-filter01')"
    },
    id: "5903438f-a8d5-4f7e-8512-d43fb7b2d043__radg01",
    cx: 106.65,
    cy: 225.069,
    rx: 20.595,
    ry: 20.227,
    transform: "matrix(2.1161 0 0 1.80829 -109.011 -154.798)"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#5903438f-a8d5-4f7e-8512-d43fb7b2d043__radg01",
    transform: "translate(97.19 -263.277)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M289.9 85.4c0-3.3-.6-6.6-1.9-9.8-1.2-3-3-5.7-5.4-8.1-2.6-2.6-5.5-4.4-8.7-5.4-3.1-1-7.4-1.5-12.9-1.5h-72.8v49.8H261c5.4 0 9.7-.5 12.9-1.5 3.2-1 6-2.8 8.7-5.4 2.4-2.4 4.2-5 5.4-8.1 1.3-3.4 1.9-6.7 1.9-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M289.9 146.2c0-3.3-.6-6.6-1.9-9.8-1.2-3-3-5.7-5.4-8.1-2.6-2.6-5.5-4.4-8.7-5.4-3.1-1-7.4-1.5-12.9-1.5h-72.8V171H261c5.4 0 9.7-.5 12.9-1.5 3.2-1 6-2.8 8.7-5.4 2.4-2.4 4.2-5 5.4-8.1 1.3-3.2 1.9-6.5 1.9-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M178 110.2c-2.4-32.3-25.4-53-61.3-53-37.8 0-61.6 23.1-61.6 58.5 0 36.6 24.7 58.6 61.6 58.6 36.1 0 59-20.8 61.3-53h-62.1v-11H178Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M312.1 208.8c-1.2 1.2-2.6 1.8-4.2 1.8-1.7 0-3.1-.6-4.2-1.8-1.2-1.2-1.7-2.6-1.7-4.2s.6-3 1.7-4.2c1.2-1.2 2.6-1.7 4.2-1.7 1.7 0 3.1.6 4.2 1.7 1.2 1.2 1.7 2.6 1.7 4.2.1 1.7-.5 3.1-1.7 4.2zm-7.8-7.8c-1 1-1.5 2.2-1.5 3.6s.5 2.6 1.5 3.7c1 1 2.2 1.5 3.6 1.5s2.6-.5 3.6-1.5 1.5-2.2 1.5-3.7c0-1.4-.5-2.6-1.5-3.6s-2.2-1.5-3.6-1.5-2.6.5-3.6 1.5zm3.5.3c.8 0 1.4.1 1.8.2.7.3 1 .8 1 1.7 0 .6-.2 1-.6 1.3-.2.1-.5.3-.9.3.5.1.9.3 1.1.6.2.3.4.7.4 1v1c0 .2 0 .3.1.3v.1h-1.1v-.8c0-.8-.2-1.3-.6-1.5-.2-.1-.7-.2-1.3-.2h-.9v2.6h-1.2v-6.5h2.2zm1.3 1.1c-.3-.2-.8-.2-1.4-.2h-1v2.4h1c.5 0 .9 0 1.1-.1.5-.2.7-.5.7-1 0-.7-.2-1-.4-1.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCb);
export default __webpack_public_path__ + "static/media/icon-cb.5ac2379f85b4270a6cb8ba5b75101045.svg";
export { ForwardRef as ReactComponent };